import { Component, HostListener, OnInit } from "@angular/core";
import OverlayScrollbars from "overlayscrollbars";
import { CVLocalizationService } from "../reusables/services/cv-localization.service";
import moment from "moment";
import { WorkAidsService } from "./work-aids.service";
import { YouTubeInfoService } from "../reusables/services/youtube-info.service";
import { DomSanitizer } from "@angular/platform-browser";
import { GridApi, GridOptions, ICellRendererParams } from "ag-grid-community";
import tinymce from "tinymce";

@Component({
    selector: "cv-work-aids-admin",
    templateUrl: "./work-aids.component.html",
    styleUrls: ["./work-aids.component.scss"],
})
export class WorkAidsComponent implements OnInit {
    public addMode: boolean = false;
    public editMode: boolean = false;
    public reuseMode: boolean = false;
    public showLive: boolean = false;
    public filterPopupOpen: boolean = false;
    public sortPopupOpen: boolean = false;
    public loading: boolean = false;
    public errorLoading: boolean = false;
    public readReceiptLoading: boolean = false;

    public preview: any = null; // This is a preview of the WorkAid
    public folders: any = null;
    public workAidList: any = [];
    public filteredWorkAidList: any = [];
    public workAidReadReceipt: any = null;
    public workAidResendNotification: any = null;
    public allTags: any = [];
    public imageViewerArray: any = null;
    public search: string = "";
    public readReceiptSearch: string = "";
    public sortProperty: string = "DateCreated";
    public sortReverse: boolean = true;
    public formId: number = null;

    public gridApi: GridApi;
    public gridOptionsNoForm: GridOptions = {};
    public gridOptionsForm: GridOptions = {};
    //#region Sort Variables
    public sortUpArrowName: boolean = false;
    public sortDownArrowName: boolean = false;
    public sortUpArrowParent: boolean = false;
    public sortDownArrowParent: boolean = false;
    public sortUpArrowRole: boolean = false;
    public sortDownArrowRole: boolean = false;
    public sortUpArrowRead: boolean = false;
    public sortDownArrowRead: boolean = true; // Sorts with unread at top by default
    public sortUpArrowScore: boolean = false;
    public sortDownArrowScore: boolean = false;
    public sortReceiptProperty: string = "Read";
    public sortReceiptReverse: boolean = false;
    //#endregion

    public localization = null;
    public localizationCommon = null;
    public loadingError: string = "";

    filterPopupWrapper: HTMLElement = null;
    sortPopupWrapper: HTMLElement = null;

    public tinymceEditor: any;

    public filter = {
        folder: "",
        urgent: false,
        attachments: false,
        allTags: false,
        tags: {},
    };

    public scrollOptions: OverlayScrollbars.PartialOptions = {
        scrollbars: {
            autoHide: "leave",
            autoHideDelay: 100,
            theme: "os-theme-dark",
            visibility: "auto",
        },
    };

    @HostListener('document:click', ['$event'])
    onDocumentClick(event) {
        if(this.filterPopupWrapper && !this.filterPopupWrapper.contains(event.target) && event.target.id != 'filterButton')
            this.filterPopupOpen = false;
        if(this.sortPopupWrapper && !this.sortPopupWrapper.contains(event.target) && event.target.id != 'sortButton')
            this.sortPopupOpen = false;
    }

    constructor(
        private cvLocalizationService: CVLocalizationService,
        public service: WorkAidsService,
        private youTubeService: YouTubeInfoService,
        private sanitizer: DomSanitizer
    ) {}

    async ngOnInit() {
        this.showLive = true;

        this.localization = await this.cvLocalizationService.GetSection(
            "Broadcasts"
        );
        this.localizationCommon = await this.cvLocalizationService.GetSection(
            "Common"
        );
        this.loadingError = this.cvLocalizationService.getCachedText(
            "Broadcasts",
            "No_Work_Aids_To_Display"
        );

        this.filterPopupWrapper = document.getElementById("filterPopupWrapper");
        this.sortPopupWrapper = document.getElementById("sortPopupWrapper");
        this.reset();
        this.tinymceEditor = tinymce.activeEditor;

        this.service.currentModes.subscribe((modes) => {
            this.addMode = modes.addMode;
            this.editMode = modes.editMode;
            this.reuseMode = modes.reuseMode;

            // If we are going back to the landing page, reload the workAidList
            if (!this.addMode && !this.editMode && !this.reuseMode) {
                this.workAidList = this.service.workAidList;
                this.folders = this.service.folders;
                this.allTags = this.service.allTags;

                this.filterAndSortWorkAidList(
                    this.sortProperty,
                    this.sortReverse
                );
            }
        });
    }

    async reset() {
        this.loading = true;

        const response = await this.service.loadWorkAids();

        if (response) {
            this.service.progressPopupOpen = false;
            this.workAidList = response.broadcasts;
            this.folders = response.folders;
            this.allTags = response.allTags;

            this.service.workAidList = this.workAidList;
            this.service.folders = this.folders;
            this.service.allTags = this.allTags;

            this.filter.allTags = false;
            this.errorLoading = false;

            this.filter.tags = {};
            this.allTags.forEach((tag) => {
                this.filter.tags[tag.TagText] = false;
            });

            const workAidVideoMapping = [];
            const videoIds = [];
            const youtubePromises = [];

            for (let i = 0; i < this.workAidList.length; i++) {
                const hyperlinksPromises = [];
                this.workAidList[i].VideoInfo = [];
                this.workAidList[i].Videos.forEach((video) => {
                    workAidVideoMapping.push(i);
                    videoIds.push(video);
                });

                if (this.workAidList[i].Videos.length > 0) {
                    youtubePromises.push(this.youTubeService.getYouTubeInformation(this.workAidList[i].Videos));
                }

                if(this.workAidList[i].Hyperlinks && this.workAidList[i]?.Hyperlinks.length > 0){
                    for(let j =0 ; j < this.workAidList[i].Hyperlinks.length; j++){
                        hyperlinksPromises.push(this.service.GetIFrameAvailability(this.workAidList[i].Hyperlinks[j].HyperlinkAddress));
                    }

                    const hyperlinksResponses = await Promise.all(hyperlinksPromises);
                    hyperlinksResponses.forEach((response, index) => {
                        this.workAidList[i].Hyperlinks[index].ContentSecurityPolicyViolation = response.contentSecurityPolicyViolation;
                        this.workAidList[i].Hyperlinks[index].IframeAvailability = response.responseCode;
                    });
                }
            }

            const youtubeResponses = await Promise.all(youtubePromises);
            const mapSet = [...new Set(workAidVideoMapping)];
            youtubeResponses.forEach((youtubeResponse, index) => {
                youtubeResponse?.items.forEach((item) => {
                    this.workAidList[mapSet[index]].VideoInfo.push(item.snippet);
                });
            });

            this.filterAndSortWorkAidList(this.sortProperty, this.sortReverse);
            this.loading = false;
        } else {
            this.service.progressPopupOpen = false;
            this.loadingError = this.cvLocalizationService.getCachedText(
                "Broadcasts",
                "Error_Retrieving_Work_Aids"
            );
            this.loading = false;
        }
    }

    checkSelectedAllTags(){
        const index = Object.values(this.filter.tags).findIndex(value => value === false);
        this.filter.allTags = index === -1;
    }

    setSelectedAllTags() {
        this.allTags.forEach((tag) => {
            this.filter.tags[tag.TagText] = this.filter.allTags;
        });
        this.filteredWorkAidList = this.getFilteredWorkAidList();
    }

    filterAndSortWorkAidList(sortProperty: string, sortReverse: boolean) {
        this.sortProperty = sortProperty;
        this.sortReverse = sortReverse;

        this.workAidList.sort((a, b) => {
            const elementA =
                typeof a[sortProperty] === "string"
                    ? a[sortProperty].toLowerCase()
                    : a[sortProperty];
            const elementB =
                typeof b[sortProperty] === "string"
                    ? b[sortProperty].toLowerCase()
                    : b[sortProperty];

            if (elementA < elementB) {
                return sortReverse ? 1 : -1;
            } else if (elementA > elementB) {
                return sortReverse ? -1 : 1;
            } else {
                return 0;
            }
        });

        this.filteredWorkAidList = this.getFilteredWorkAidList();
    }

    toggleShowLive(showLive: boolean) {
        this.showLive = showLive;
        this.preview = null;
        this.filteredWorkAidList = this.getFilteredWorkAidList();
    }

    displayableWorkAidsCount() {
        let count = 0;
        this.workAidList.forEach((workAid) => {
            if (this.liveArchivedFilter(workAid)) count++;
        });
        return count;
    }

    liveArchivedFilter(workAid) {
        return (
            (this.workAidIsLive(workAid) && this.showLive) ||
            (!this.workAidIsLive(workAid) && !this.showLive)
        ); // This logic is workAidIsLive(workAid) XOR !showLive
    }

    workAidIsLive(workAid) {
        if (workAid != null) {
            if (workAid.ExpirationDate == null) return true;
            return Date.now() < new Date(workAid.ExpirationDate).getTime();
        }
        return false;
    }

    folderFilter(workAidFolder) {
        if (this.filter.folder == "" || this.filter.folder == null) return true;
        return this.filter.folder == workAidFolder;
    }

    urgentFilter(workAidUrgent) {
        // Will always show if the work aid is marked as urgent, will always show if filter is turned off,
        // will not show if both the above conditions aren't met
        return workAidUrgent || !this.filter.urgent;
    }

    attachmentsFilter(workAid) {
        // Will always show if the work aid has attachments, will always show if filter is turned off,
        // will not show if both the above conditions aren't met
        return workAid.Attachments.length > 0 || workAid.Videos.length > 0 || workAid.Images.length > 0 || workAid.Hyperlinks.length > 0 || !this.filter.attachments;
    };

    handleFilterChange() {
        this.filteredWorkAidList = this.getFilteredWorkAidList();
    }

    tagFilter(workAidTags): boolean {
        var result = true;

        this.allTags.forEach((tag) => {
            if (this.filter.tags[tag.TagText]) {
                if (
                    workAidTags
                        .map((e) => {
                            return e.TagText;
                        })
                        .indexOf(tag.TagText) < 0
                )
                    result = false;
            }
        });

        return result;
    }

    // Moved the filtering to a function instead of within html
    // due to Angular not supporting multiple template bindings on one element.
    getFilteredWorkAidList() {
        const filteredList = [];

        this.workAidList.forEach((workAid) => {
            if (
                this.folderFilter(workAid.Folder) &&
                this.liveArchivedFilter(workAid) &&
                this.urgentFilter(workAid.Urgent) &&
                this.attachmentsFilter(workAid) &&
                this.tagFilter(workAid.Tags)
            )
                filteredList.push(workAid);
        });

        return filteredList;
    }

    workAidClicked(workAid) {
        this.preview = workAid;
        this.preview.TagString = this.preview.Tags.map(function (tag) {
            return tag.TagText;
        }).join(", ");
    }

    isOverflown(workAidId) {
        var element = document.getElementById("workAid" + workAidId);
        return (
            element.scrollHeight > element.clientHeight ||
            element.scrollWidth > element.clientWidth
        );
    }

    editWorkAid(workAid) {
        this.editMode = true;
        this.preloadFields(workAid);
    }

    reuseWorkAid(workAid) {
        this.reuseMode = true;
        this.preloadFields(workAid);
    }

    async preloadFields(workAid) {
        this.preview = null;
        let tags = "";
        workAid.Tags.forEach((tag) => {
            tags += tag.TagText + ", ";
        });
        tags = tags.substring(0, tags.length - 2);
        const convertedDate = new Date(workAid.ExpirationDate);
        this.service.save = {
            BroadcastID: workAid.BroadcastID,
            Title: workAid.Title,
            BroadcastText: workAid.BroadcastText,
            Folder: workAid.Folder,
            Urgent: workAid.Urgent,
            ExpirationDate:
                Date.now() < convertedDate.getTime()
                    ? convertedDate
                    : null,
            Quiz: workAid.FormID,
            OriginalQuiz: workAid.FormID,
            FormID: workAid.FormID == 0 ? null : workAid.FormID,
            Recipients: [],
            RecipientAssignments: [],
            Attachments: workAid.Attachments.slice(0),
            Images: workAid.Images.slice(0),
            ImagesData: new Array(workAid.Images.length).fill(null),
            Hyperlinks: workAid.Hyperlinks.slice(0),
            Videos: workAid.Videos.slice(0),
            VideoInfo: workAid.VideoInfo.slice(0),
            TagsList: tags,
            MinorEdit: false,
        };
        if (workAid.RecipientAssignments == null) {
            this.service.loadingRecipients = true;
            const response = await this.service.GetRecipientAssignments(
                workAid.BroadcastID
            );

            if (response) {
                workAid.RecipientAssignments = response;
                this.service.loadingRecipients = false;
                this.service.save.RecipientAssignments =
                    workAid.RecipientAssignments.slice(0);
            }
        } else {
            this.service.save.RecipientAssignments = workAid.RecipientAssignments.slice(0);
        }
        if (workAid.FormID != null && this.service.quizzes == null) {
            const response = await this.service.GetAccessibleQuizzes();
            if(response){
                this.service.quizzes = response;
            }
        }

        this.changeMode(this.addMode, this.editMode, this.reuseMode);
    }

    async archiveWorkAid(workAidId) {
        this.service.progressPopupOpen = true;
        await this.service.ArchiveWorkAid(workAidId);

        this.preview = null;
        this.reset();
    }

    async deleteWorkAid(workAidId) {
        this.service.progressPopupOpen = true;
        await this.service.DeleteWorkAid(workAidId);

        this.preview = null;
        this.reset();
    }

    async openReadReceipt(workAid) {
        this.workAidResendNotification = null;
        this.workAidReadReceipt = workAid;
        if (workAid.ReadReceipt == null && !this.readReceiptLoading) {
            this.readReceiptLoading = true;
            const data = await this.service.GetReadReceipt(workAid.BroadcastID);

            if (data) {
                workAid.ReadReceipt = data;
                this.readReceiptLoading = false;
            }
        }
        this.setupReadReceiptAgGrid(workAid);
        this.resolveReadReceiptSorting(workAid);
    }

    closeReadReceipt(){
        this.workAidReadReceipt = null; 
        this.workAidResendNotification = null; 
        this.readReceiptSearch = "";
        this.imageViewerArray = null;
        this.service.score = null;
    }

    setupReadReceiptAgGrid(workAid) {
        this.gridOptionsForm = null;
        this.gridOptionsNoForm = null;

        this.gridOptionsNoForm = {
            defaultColDef:{
                editable: false,
                sortable: true,
            },
            accentedSort: true,
            animateRows: true,
            suppressCellFocus: true,
            suppressDragLeaveHidesColumns: true,
            suppressScrollOnNewData: true,
            columnDefs: [
                {
                    field: "LoginName",
                    colId: "LoginNameNoForm",
                    headerName: "User",
                    menuTabs: [],
                },
                {
                    field: "ParentGroupName",
                    colId: "ParentGroupNameNoForm",
                    headerName: "Parent Group",
                    menuTabs: [],
                },
                {
                    field: "Role",
                    colId: "RoleNoForm",
                    headerName: "Role",
                    menuTabs: [],
                },
                {
                    field: "Read",
                    colId: "ReadNoForm",
                    headerName: "Read",
                    cellRenderer: params => {
                        return params.value
                            ? '<div><svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg></div>'
                            : "";
                    },
                    sort: "desc",
                    menuTabs: [],
                },
            ],
            onGridReady: params => {
                this.gridApi = params.api;
                if (workAid.ReadReceipt)
                    params.api.setGridOption('rowData', workAid.ReadReceipt);
                params.api.sizeColumnsToFit();
            },
            rowData: workAid.ReadReceipt,
        };

        const formLink = (params: ICellRendererParams) => {
            if (params.data.Score) {
                const element = document.createElement("div");
                element.innerHTML ='<span class="color-cerulean clickable">' +params.value +"</span>";
                element.addEventListener("click", () => {
                    this.openQuizPreview(
                        workAid.FormID,
                        params.data.RecordingID,
                        params.data.Score,
                    );
                });
                return element;
            } else
                return "<span>" + params.value + "</span>";
        };

        this.gridOptionsForm = {
            defaultColDef:{
                editable: false,
                sortable: true,
            },
            accentedSort: true,
            animateRows: true,
            suppressCellFocus: true,
            suppressDragLeaveHidesColumns: true,
            columnDefs: [
                {
                    field: "LoginName",
                    colId: "LoginNameForm",
                    headerName: "User",
                    cellRenderer: formLink,
                    menuTabs: [],
                },
                {
                    field: "ParentGroupName",
                    colId: "ParentGroupNameForm",
                    headerName: "Parent Group",
                    menuTabs: [],
                },
                {
                    field: "Role",
                    colId: "RoleForm",
                    headerName: "Role",
                    menuTabs: [],
                },
                {
                    field: "Score",
                    colId: "ScoreForm",
                    headerName: "Score",
                    cellRenderer: params => {
                        var cellContents = "<div>";
                        if (params.value == null) cellContents += "-";
                        else if (params.value == -1)
                            cellContents +=
                                '<svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>';
                        else
                            cellContents +=
                                (parseFloat(params.value) * 100).toFixed(2) +
                                "%";
                        cellContents += "</div>";
                        return cellContents;
                    },
                    sort: "desc",
                    menuTabs: [],
                },
            ],
            onGridReady: params => {
                this.gridApi = params.api;
                if (workAid.ReadReceipt)
                    params.api.setGridOption('rowData', workAid.ReadReceipt);
                params.api.sizeColumnsToFit();
            },
            rowData: workAid.ReadReceipt,
        };
    }

    applyFilter() {
        if (this.gridApi) { // notify filter change
            this.gridApi.setGridOption('quickFilterText', this.readReceiptSearch.trim());
        }
    }

    resolveReadReceiptSorting(workAid) {
        // True if any of the entries in the read receipt have a "Score" value that isn't null, false if all scores are null
        const hasScores = workAid.ReadReceipt.map(function (e) {
            return e.Score;
        }).some(function (el) {
            return el != null;
        });
        if (hasScores && this.sortReceiptProperty == "Read") {
            this.sortReceiptProperty = "Score";
            this.sortDownArrowScore = this.sortDownArrowRead;
            this.sortUpArrowScore = this.sortUpArrowRead;
            this.sortReceiptReverse = !this.sortReceiptReverse;
        } else if (!hasScores && this.sortReceiptProperty == "Score") {
            this.sortReceiptProperty = "Read";
            this.sortDownArrowRead = this.sortDownArrowScore;
            this.sortUpArrowRead = this.sortUpArrowScore;
            this.sortReceiptReverse = !this.sortReceiptReverse;
        }
    }

    async exportReadReceipt() {
        const data = await this.service.ExportReadReceipt(
            this.workAidReadReceipt.BroadcastID
        );

        if (data) {
            var decodedData = atob(data);
            var buffer = new ArrayBuffer(decodedData.length);
            var view = new Uint8Array(buffer);
            for (var i = 0; i != decodedData.length; ++i) {
                view[i] = decodedData.charCodeAt(i) & 0xff;
            }
            var fileData = [buffer];
            var mimeType = "text/csv"; //"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            var blobObject = new Blob(fileData, { type: mimeType });
            if ((window.navigator as any).msSaveOrOpenBlob) {
                (window.navigator as any).msSaveOrOpenBlob(
                    blobObject,
                    this.workAidReadReceipt.Title
                );
            } else {
                var linkElement = document.createElement("a");
                document.body.appendChild(linkElement);
                linkElement.setAttribute("style", "display:none");
                var url = URL.createObjectURL(blobObject);
                linkElement.href = url;
                linkElement.download = this.workAidReadReceipt.Title + ".csv";
                linkElement.click();
                URL.revokeObjectURL(linkElement.href);
                linkElement.remove();
            }
        } //error
        else {
            console.error("Error exporting file");
        }
    }

    getRelativeTime(datetime, utcDatetime) {
        const dateCreated = new Date(datetime);
        const utcDateCreated = new Date(utcDatetime);
        let relativeTime;
        if (
            dateCreated.isToday(dateCreated) &&
            dateCreated < new Date().addMinutes(-10)
        )
            relativeTime = utcDateCreated.toString(CVTimeFormat);
        else relativeTime = moment(utcDateCreated).fromNow();
        return relativeTime;
    }

    openResendNotification(workAid) {
        this.workAidReadReceipt = null;
        this.workAidResendNotification = workAid;
    }

    async resendNotification(workAidId) {
        await this.service.ResendNotification(workAidId);
        this.workAidResendNotification = null;
    }

    openQuizPreview(formId, recordingId, score) {
        if (recordingId && recordingId > 0) {
            this.service.save.FormID = formId;
            this.service.recordingId = recordingId;
            this.service.quizPreviewEditable = false;
            this.service.quizPreviewShowScore = score && score > -1; 
            this.service.score = score;
            this.service.quizPopupOpen = true;
        }
    }


    changeMode(
        addMode: boolean = false,
        editMode: boolean = false,
        reuseMode: boolean = false
    ) {
        this.addMode = addMode;
        this.editMode = editMode;
        this.reuseMode = reuseMode;
        this.service.changeMode(addMode, editMode, reuseMode);
    }

    trustAsHtml(string) {
        return this.sanitizer.bypassSecurityTrustHtml(string);
    }
}
